import request from '../../utils/request'
import config from '../../../config/config'
const baseURL = config.baseUrl;
//  管理员登录
export function login (data) {
  
  return request({
    url: baseURL + 'users/adminLogin',
    method: 'post',
    data: data
  })
}
//  用户列表
export function userList (data) {
  return request({
    url: baseURL + 'users/list',
    method: 'post',
    data: data
  })
}
//  用户列表
export function userUpdate (data) {
  return request({
    url: baseURL + 'users/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user/user.js